import React from 'react'
import '../assets/scss/main.scss'
import Header from './Header'
import Menu from './Menu'
import Footer from './Footer'
import { Plugins } from '@capacitor/core';

const isBrowser = typeof window !== "undefined"
const { Device } = Plugins;

class Layout extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isMenuVisible: false,
            loading: 'is-loading',
            showFooter: true,
            isApp: false,
        }
        this.handleToggleMenu = this.handleToggleMenu.bind(this)
    }

    componentDidMount () {
        this.timeoutId = setTimeout(() => {
            this.setState({loading: ''});
        }, 100);

        

        if (isBrowser) {
            const info = Device.getInfo();
            var that = this;
            info.then(function(v){
                console.log(v.platform);
                if (v.platform == "ios") {
                    if (window.Capacitor && window.Capacitor.Plugins.IosSwipeBack) {
                        window.Capacitor.Plugins.IosSwipeBack.enable()
                        .then(res => console.log('swipe back enabled', res))
                        .catch(err => console.error('error with swipe back', err))
                    }
                }
                //if (v.platform === "ios" || v.platform === "android") {
                 if (v.platform == "web") {
                    that.setState({
                        showFooter: true,
                        isApp: false,
                    }, () => that.props.handler());
                }
            });
        }
    }

    componentWillUnmount () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    handleToggleMenu() {
        this.setState({
            isMenuVisible: !this.state.isMenuVisible
        })
    }

    render() {
        const { children } = this.props

        return (
            <>
            
            <div className="mainbg">
                <div className={`body ${this.state.loading} ${this.state.isMenuVisible ? 'is-menu-visible' : ''}`}>
                    <div id="wrapper">
                        <Header onToggleMenu={this.handleToggleMenu} cl={this.props.cl} bla={this.props}/>
                        {children}
                        {this.state.showFooter ? (<Footer />) : (<></>)}
                    </div>
                    <Menu onToggleMenu={this.handleToggleMenu} isApp={this.state.isApp}/>
                </div>
            </div>
            </>
        )
    }
}

export default Layout
